import styled from 'styled-components';
import palette from '../../lib/styles/palette';

const Footer = () => {
    return (
        <FooterBlock>
            <Copyright>
                <p>Copyright 2024 M3 Engineering. All Rights Reserve.</p>
                {/* <p>Copyright 2024 IL Soft. All Rights Reserve.</p> */}
            </Copyright>
            <Info>
                <p>
                    <span className="colored">MMM</span>Engineering
                </p>
                {/* <p><span className="colored">IL</span>Soft & Engineering</p> */}
            </Info>
        </FooterBlock>
    );
};

export default Footer;

const FooterBlock = styled.div`
    max-width: 1280px;
    margin: 0 auto;
    padding: 3rem 1rem 1rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;

const Copyright = styled.div``;

const Info = styled.div`
    p {
        font-style: italic;
        font-weight: 500;
        color: ${palette.orange};
    }
    .colored {
        font-size: 1.125rem;
        color: ${palette.yachtBlue};
        margin-right: 0.25rem;
    }
`;
